import { Operation } from './Operation'

export enum IncidentType {
    RESPONSE_TIME = 'transaction-walltime',
    ERROR_RATE = 'error-rate',
    TRANSACTION_FAILURE_RATE = 'transaction-failure-rate',
    TRANSACTION_RESPONSE_TIME = 'transaction-response-time',
    ERROR_GROUP = 'error_group',
    WEEKLY_REPORT = 'weekly_report',
    RELEASE_INTEGRATION = 'release',
    TRACEPOINT = 'trace-boost',
    SLOW_SQL = 'slow-sql',
    RESPONSE_TIME_DEVIATION = 'response-time-deviation',
    MISSING_DATA = 'missing-data',
}

export function incidentIcon(type: IncidentType): string {
    // copy-adapt from \Xhprof\Bundle\AlertBundle\Twig\AlertExtension::$checkIconMap
    const map = {
        [IncidentType.RESPONSE_TIME]: 'fa-line-chart',
        [IncidentType.TRANSACTION_RESPONSE_TIME]: 'fa-line-chart',
        [IncidentType.ERROR_RATE]: 'fa-bug',
        [IncidentType.TRANSACTION_FAILURE_RATE]: 'fa-bug',
        [IncidentType.ERROR_GROUP]: 'fa-bug',
        [IncidentType.WEEKLY_REPORT]: 'fa-calendar-o',
        [IncidentType.RELEASE_INTEGRATION]: 'fa-flag',
        [IncidentType.TRACEPOINT]: 'fa-crosshairs',
        [IncidentType.SLOW_SQL]: 'fa-database',
        [IncidentType.MISSING_DATA]: 'fa-heartbeat',
    }

    return map[type] ?? 'fa-exclamation-circle'
}

export interface Incident {
    id: number
    type: IncidentType
    startDate: string
    endDate: string | null
    alerts: Array<BaseAlert | TransactionFailureRateAlert>
    transaction: Operation | null
    service: string
    environment: string
    duration: number
    threshold: string
    lastValue: string
}

export interface TransactionFailureRateIncident extends Incident {
    alerts: TransactionFailureRateAlert[]
}

export interface Alert {
    date: string
    value: string
    threshold: string
    severity: string
}

interface BaseAlert extends Alert {
    data: string
}

interface TransactionFailureRateAlert extends Alert {
    data: {
        errors: {
            total: number
            entries: Array<{
                errorRate: number
                id: number
                name: string
            }>
        }
    }
}

export const isAnyFailureRateIncident = (incident: Incident) => {
    return incident.type === IncidentType.TRANSACTION_FAILURE_RATE || incident.type === IncidentType.ERROR_RATE
}
